<template>
  <div>
    <div class="p-8 bg-gray-800">
      <div class="max-w-7xl mx-auto">
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex-1 min-w-0">
            <h2 class="text-2xl font-bold leading-7 text-white sm:text-3xl sm:truncate">
              Contact Requests
            </h2>
          </div>
          <div class="mt-4 flex md:mt-0 md:ml-4 space-x-2">
            <!-- Actions -->
          </div>
        </div>
      </div>
    </div>
    <div class="p-8">
      <div class="max-w-7xl mx-auto">
        <ContactRequestList :account-id="accountId" />
      </div>
    </div>
  </div>
</template>

<script>
import ContactRequestList from './contactRequests/components/ContactRequestList.vue';

export default {
  components: {
    ContactRequestList,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  mounted() {
    if (this.$route.query.contact_request_id) {
      this.$modal.show({
        component: 'ContactRequestModal',
        props: {
          contactRequestId: this.$route.query.contact_request_id,
        },
        on: {
          hide: () => {
            this.$emit('edited', this.$route.query.contact_request_id);
          },
        },
        hideEvent: 'hide',
      });
    }
  },
};
</script>
